import { z } from 'zod';

export const getAnamnesisSchema = z.object({
  patient_id: z.string().min(1),
});

export type GetAnamnesisPayload = z.infer<typeof getAnamnesisSchema>;
